import { DeviceType } from './realtime.types';

/**
 * Best-effort browser/device detection based on the user agent string.
 * The result is sent in the WS `IDENTIFY` envelope; misclassification is
 * not a security concern — the backend trusts the JWT for everything that
 * matters and uses this field for diagnostics only.
 */
export function detectDeviceType(userAgent?: string): DeviceType {
  const ua = (
    userAgent ??
    (typeof navigator !== 'undefined' ? navigator.userAgent : '') ??
    ''
  ).toLowerCase();
  if (!ua) {
    return DeviceType.OTHER;
  }

  if (/iphone|ipad|ipod/.test(ua)) {
    return DeviceType.MOBILE_IOS;
  }
  if (/android/.test(ua)) {
    return DeviceType.MOBILE_ANDROID;
  }
  if (/\bedg\//.test(ua)) {
    return DeviceType.EDGE;
  }
  if (/\bopr\/|\bopera\b/.test(ua)) {
    return DeviceType.OPERA;
  }
  if (/firefox|fxios/.test(ua)) {
    return DeviceType.FIREFOX;
  }
  if (/chrome|crios|chromium/.test(ua) && !/edg\/|opr\//.test(ua)) {
    return DeviceType.CHROME;
  }
  if (/safari/.test(ua) && !/chrome|chromium|crios/.test(ua)) {
    return DeviceType.SAFARI;
  }
  return DeviceType.OTHER;
}
